import { UserResponse } from '../../../providers/User/User.model';
import { DriverFileType } from '../driverFileType/driverFileType.model';

export enum DRIVER_FILE_STATUS {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  EXPIRING_WITHIN_30_DAYS = 'EXPIRING_WITHIN_30_DAYS'
}
export interface DriverFile {
  id: string;
  driver_id: string;
  driver_file_type_id: string;
  driver_file_type: DriverFileType;
  status: DRIVER_FILE_STATUS | null;
  expiration_date: Date | null;
  driver_file_attachments: DriverFileAttachment[];
}

export type UpdateDriverFileData = Pick<DriverFile, 'expiration_date'>;

export type DeleteDriverFileResponse = {
  message: string;
};

export interface DriverFileAttachment {
  id: string;
  driver_file_id: string;
  attachment_id: string;
  tenant_id: string;
  attachment: AttachmentFile;
  created_at?: Date;
  created_by?: string;
  createdBy?: UserResponse;
}

export interface AttachmentBasicProps {
  file_type: string;
  id: string;
  created_at: string;
  created_by: string;
}

export type AttachmentFile = File & AttachmentBasicProps;

export interface DriverFileAttachmentParams {
  attachments: AttachmentFile[];
}

export interface DriverFileAttachmentsResponse {
  total: number;
  data: DriverFileAttachment[];
}
